import * as Sentry from '@sentry/browser';

import Breadcrumb from '../Breadcrumb';
import reporters from '../consoleReporters';
import formatLogData from '../formatLogData';
import LoggerAdapter from '../LoggerAdapter';
import LoggerUserData from '../LoggerUserData';
import Severity from '../Severity';

type SentryClient = typeof Sentry;

export default class SentryLoggerAdapter implements LoggerAdapter {
    private client: SentryClient;

    public constructor(sentryClient: SentryClient) {
        this.client = sentryClient;
    }

    public addBreadcrumb(breadcrumb: Breadcrumb): void {
        this.client.addBreadcrumb({
            ...breadcrumb,
            level: breadcrumb.level as unknown as Sentry.SeverityLevel,
            data: formatLogData(breadcrumb.data),
        });
    }

    public setUser(userData: LoggerUserData | null): void {
        this.client.setUser(userData);
    }

    public setTags(tags: Record<string, string>): void {
        for (const key of Object.keys(tags)) {
            this.client.setTag(key, tags[key]);
        }
    }

    public log(level: Severity, message: string | Error): void {
        return reporters[level](message);
    }
}
